export default __webpack_public_path__ + "static/media/note-ecom.2a60bff6.png";